<template>
    <div class="fixed left-[50%] translate-x-[-50%] top-[50%] translate-y-[-50%] z-[1000] bg-white2 border-rose-emb w-[1000px] h-[500px] rounded-[10px] pt-[10px] border-[1px] ">
        <div class="bg-rose-emb text-gray-emb text-[13px] uppercase font-medium text-center rounded-[4px] mx-[14px] py-[1.2px]">
            Активність клієнта
        </div>
        
        <div class="px-[20px] overflow-y-auto h-[400px]">
            <div v-for="activity in studentActivity" class="flex gap-[10px] items-center mt-[10px]">
                <div class="text-[10px] text-center">
                    {{ activity.activity_date.split('T')[0].split('-').reverse().join('.') }}
                    <br>
                    {{ activity.activity_date.split('T')[1].split('.')[0] }}
                </div>
                <div><span v-html="activity.activity_description"></span></div>
            </div>
        </div>

    </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { getStudentActivity } from '@/services/apiRequests'

export default {
    name: 'ClientActivityCard',    

    props: {
        user: {
            type: Object,
            default: () => {}
        }
    },

    setup(props) {
        const studentActivity = ref(null)

        onMounted(async () => {
            // try {
            const response = await getStudentActivity(props.user.student_id)
            studentActivity.value = response.data.reverse()
            console.log('Student activity:', studentActivity.value)
            // } catch (error) {
            //     console.error('Error fetching student activity:', error)
            // }
        })

        return {
            studentActivity
        }
    }
}
</script>

<style lang="">
    
</style>